import { GeckoMeasurement, GeckoMeasurementUnit } from 'types'

/**
 * Pinned MAWP seed defaults.
 *
 * These initialize the FFS MAWP shared state (`FfsSharedValues`: `yieldStrength`
 * and `tensileStrength`). They used to be derived from the allowable-stress table
 * module's default row (ASME material `A516 Gr. 60 / A106 / B`). That coupling
 * broke when the table data was replaced with the ASME B31.3-2022 Table A-1
 * low/intermediate alloy-steel set, which does not contain the carbon-steel
 * `A106 B` row — deriving the default from the new dataset would yield `null` and
 * cascade to `mawp_c`/`mawp_l === null`, making `failingMawpCriteria` read as
 * "not failing" instead of "calculation incomplete".
 *
 * So the historical default is pinned here explicitly (values in ksi → psi):
 *   - allowable stress S = 20 ksi   (A106 B basic allowable at ≤100 °F)
 *   - min tensile        = 60 ksi   (A106 B SMTS)
 *
 * When the corrected carbon-steel section of Table A-1 is added to the picker,
 * `A106 B` becomes selectable again and these pins can point at that record.
 */
export const DEFAULT_STRESS_VALUE: GeckoMeasurement =
  GeckoMeasurement.CreateFromValue(
    20 * 1000,
    GeckoMeasurementUnit.PoundsForcePerSqInch
  )

export const DEFAULT_TENSILE_STRENGTH: GeckoMeasurement =
  GeckoMeasurement.CreateFromValue(
    60 * 1000,
    GeckoMeasurementUnit.PoundsForcePerSqInch
  )
